<template>
  <div class="md-layout md-alignment-center">
    <md-progress-spinner :md-diameter="diameter" :md-stroke="stroke" md-mode="indeterminate"></md-progress-spinner>
  </div>
</template>

<script>
  export default {
    props: {
      diameter: {
        type   : Number,
        default: 30,
      },
      stroke: {
        type   : Number,
        default: 3,
      },
    },
  }
</script>

<style lang="scss">
  .md-progress-spinner {
    margin: 12px;
  }
</style>
